import { ENVIRONMENT } from "../app.constants";
import { environment } from "../../environments/environment";

const { ENV, name } = environment;

export const electronApi = typeof window === "undefined" ? undefined : (window as any)?.electronApi;

export const isLocal = (): boolean => {
  return name === ENVIRONMENT.LOCAL;
};

export const isDevelopment = (): boolean => {
  return ENV === "development" || isLocal();
};

export const isStaging = (): boolean => {
  return ENV === "staging";
};

export const isProduction = (): boolean => {
  return ENV === "production";
};

export const isElectron = (): boolean => {
  return Boolean(electronApi);
};
